import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Branches from './components/Branches';
import SocialLinks from './components/SocialLinks';
import Footer from './components/Footer';
import WelcomePopup from './components/WelcomePopup';

function App() {
  return (
    <div className="app-container">
      <WelcomePopup />
      <Navbar />
      <Hero />
      <Features />
      <Branches />
      <SocialLinks />
      <Footer />
    </div>
  );
}

export default App;
